import { overwrite, getName, getNames, getCode, getCodes } from "country-list";

const countryOverwrites = [
  {
    code: "GB",
    name: "United Kingdom",
  },
  {
    code: "TW",
    name: "Taiwan",
  },
  {
    code: "US",
    name: "United States",
  },
];

countryOverwrites.forEach((country) => overwrite([country]));

export function useCountry() {
  const getCountryName = (code: string) => {
    return getName(code) || code;
  };

  const getCountries = () => {
    const c = getNames();
    c.sort((a: any, b: any) => a.localeCompare(b));

    return c;
  };

  const getCountryCode = (name: string) => {
    return getCode(name);
  };

  const getCountryCodes = () => {
    return getCodes();
  };

  return {
    getCountryName,
    getCountries,
    getCountryCode,
    getCountryCodes,
  };
}
